import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-575486bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-card ss-fadein" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ss-div-icone-etapa" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "ss-icone-etapa",
    img: "",
    src: "/static/img/configuracao-inicial/icone-financeiro.png"
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "ant-col ss-div-conteudo"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-card" }, "Defina como devemos controlar seu dinheiro", -1))
const _hoisted_6 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Tipos de Documento que vou usar", -1))
const _hoisted_8 = { class: "ant-col ss-div-multi-selecao" }
const _hoisted_9 = {
  key: 1,
  class: "ant-divider ant-divider-horizontal ss-div-separador",
  role: "separator"
}
const _hoisted_10 = {
  key: 2,
  class: "ant-row ss-div-switch"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Vou usar a forma de pagamento padrão", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Criar uma forma de pagamento", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 3,
  class: "ant-row ss-div-switch"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Vou usar o plano de contas padrão", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Criar um plano de contas", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 4,
  class: "ant-row ss-div-switch"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Vou usar o centro de custo padrão", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Criar um centro de custo", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 5,
  class: "ant-row ss-div-switch"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Vou usar a conta padrão", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Criar uma conta", -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 1,
  class: "ant-col ss-div-conteudo"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-card" }, "Defina como devemos controlar seu dinheiro", -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "ant-col ss-div-icone-etapa" }
const _hoisted_38 = {
  key: 0,
  class: "ss-icone-etapa ss-fadein",
  img: "",
  src: "/static/img/configuracao-inicial/icone-feito.png"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_generico_string = _resolveComponent("selecionar-generico-string")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_forma_pagamento_modal = _resolveComponent("forma-pagamento-modal")!
  const _component_plano_conta_modal = _resolveComponent("plano-conta-modal")!
  const _component_centro_custo_modal = _resolveComponent("centro-custo-modal")!
  const _component_conta_modal = _resolveComponent("conta-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.computedConfiguracao.etapaAtual === _ctx.EEtapaConfiguracaoInicial.Financeiro)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            (_ctx.state.permissaoTipoDocumentoFinanceiro)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_selecionar_generico_string, {
                      placeholder: "Escolha seus tipos de pagamento",
                      itens: _ctx.state.optionsTipoDocumentoFinanceiro,
                      varios: true,
                      valoresSelecionados: _ctx.state.tiposDocumentosFinanceiroSelecionados,
                      "onUpdate:valoresSelecionados": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.tiposDocumentosFinanceiroSelecionados) = $event))
                    }, null, 8, ["itens", "valoresSelecionados"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.permissaoTipoDocumentoFinanceiro)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9))
              : _createCommentVNode("", true),
            (_ctx.state.permissaoFormaPagamento)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_a_switch, {
                    class: "ss-switch",
                    checked: _ctx.computedConfiguracao.usarFormaPagamentoPadrao,
                    "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedConfiguracao.usarFormaPagamentoPadrao) = $event))
                  }, null, 8, ["checked"]),
                  (_ctx.computedConfiguracao.usarFormaPagamentoPadrao)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.abrirFormaPagamento && _ctx.abrirFormaPagamento(...args)))
                      }, _hoisted_15))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.permissaoPlanoContas)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_a_switch, {
                    class: "ss-switch",
                    checked: _ctx.computedConfiguracao.usarPlanoContasPadrao,
                    "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedConfiguracao.usarPlanoContasPadrao) = $event))
                  }, null, 8, ["checked"]),
                  (_ctx.computedConfiguracao.usarPlanoContasPadrao)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.abrirPlanoContas && _ctx.abrirPlanoContas(...args)))
                      }, _hoisted_21))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.permissaoCentroCusto)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_a_switch, {
                    class: "ss-switch",
                    checked: _ctx.computedConfiguracao.usarCentroCustoPadrao,
                    "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedConfiguracao.usarCentroCustoPadrao) = $event))
                  }, null, 8, ["checked"]),
                  (_ctx.computedConfiguracao.usarCentroCustoPadrao)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.abrirCentroCusto && _ctx.abrirCentroCusto(...args)))
                      }, _hoisted_27))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.permissaoConta)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createVNode(_component_a_switch, {
                    class: "ss-switch",
                    checked: _ctx.computedConfiguracao.usarContaPadrao,
                    "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedConfiguracao.usarContaPadrao) = $event))
                  }, null, 8, ["checked"]),
                  (_ctx.computedConfiguracao.usarContaPadrao)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.abrirConta && _ctx.abrirConta(...args)))
                      }, _hoisted_33))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.concluindo)
              ? (_openBlock(), _createBlock(_component_a_alert, {
                  key: 6,
                  description: "Lançando novos registros isso pode demorar um pouco.",
                  style: {"white-space":"pre","margin-top":"5px"},
                  type: "info",
                  "show-icon": ""
                }))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36)),
      _createElementVNode("div", _hoisted_37, [
        (_ctx.computedConfiguracao.etapaAtual !== _ctx.EEtapaConfiguracaoInicial.Financeiro)
          ? (_openBlock(), _createElementBlock("img", _hoisted_38))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "ss-botao-concluir",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.concluir && _ctx.concluir(...args)))
            }, [
              _createVNode(_component_a_spin, {
                spinning: _ctx.state.carregando
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Concluir!")
                ]),
                _: 1
              }, 8, ["spinning"])
            ]))
      ])
    ]),
    _createVNode(_component_forma_pagamento_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirFormaPagamento,
      "onUpdate:visivel": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.exibirFormaPagamento) = $event))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_plano_conta_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirPlanoContas,
      "onUpdate:visivel": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.exibirPlanoContas) = $event))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_centro_custo_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirCentroCusto,
      "onUpdate:visivel": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.exibirCentroCusto) = $event))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_conta_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirConta,
      "onUpdate:visivel": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.exibirConta) = $event))
    }, null, 8, ["operacao", "visivel"])
  ]))
}